import { type ButtonHTMLAttributes, forwardRef } from "react";
import { cn } from "@/shared/cn";

export interface PanelToggleProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
}

export const PanelToggle = forwardRef<HTMLButtonElement, PanelToggleProps>(function PanelToggle(
  { label, className, children, type = "button", ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      aria-label={label}
      title={label}
      data-panel-toggle
      className={cn(PANEL_TOGGLE_CLASS, className)}
      {...rest}
    >
      {children}
    </button>
  );
});

const PANEL_TOGGLE_CLASS = cn(
  "inline-grid size-[32px] shrink-0 cursor-pointer place-items-center rounded-[4px] border-0 bg-transparent p-0 text-(--muted)",
  "transition-colors duration-(--duration-fast) [&_svg]:size-[18px] [&_svg]:[stroke-width:2]",
  "hover:bg-(--fill) hover:text-(--ink)",
  "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--brand)",
  "disabled:cursor-default disabled:opacity-45",
);
